import { Avatar, Card, Collection, CollectionLink, SectionHeader } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { useEffect, useState } from 'react';
import { getSelectedLanguage } from '@frontend/translate';
import type { IGroupGetOne } from '../../interfaces/groupGetOne';
import { useAbortableFetch } from '../../../utils/hooks/useAbortableFetch';

interface IGroupOrganizationProps {
    groupId: string;
}

export function GroupOrganizationsOverview(props: IGroupOrganizationProps): JSX.Element {
    const navigate = useNavigate();
    const abortableFetch = useAbortableFetch();
    const [group, setGroup] = useState<IGroupGetOne>();
    const { groupId } = props;
    const translate = getSelectedLanguage();

    useEffect(() => {
        if (groupId) {
            loadGroup(groupId);
        }
    }, [groupId]);

    if (!group || !groupId) {
        return <></>;
    }

    return (
        <>
            {group.organizations && group.organizations.length > 0 && (
                <Collection
                    aria-label="organisatie lijst"
                    type="nav"
                >
                    <SectionHeader title={translate.organization.organizations} />
                    {group.organizations &&
                        group.organizations.map((organization, i) => (
                            <Card key={i}>
                                <CollectionLink
                                    key={i}
                                    mediaItem={
                                        <Avatar
                                            icon="organization"
                                            shape="square"
                                            size={40}
                                        />
                                    }
                                    onClick={async () => {
                                        redirectToOrganizationPage(organization.id);
                                    }}
                                    padding="medium"
                                    title={organization.name}
                                ></CollectionLink>
                            </Card>
                        ))}
                </Collection>
            )}
        </>
    );

    function redirectToOrganizationPage(organizationId: string) {
        navigate(`/organizations/${organizationId}/view`);
    }

    async function loadGroup(groupIdentifier: string) {
        const url = `/api/groups/${groupIdentifier}`;
        const result = await abortableFetch.fetchJson(url, 'GET');
        setGroup(result.json);
    }
}
